import { createAction } from '@ngrx/store';

export const NullAction = createAction('[App] Dispatch null action');
